import {
  Component, OnInit, ViewChild,
  ElementRef, AfterViewChecked, ChangeDetectorRef
} from '@angular/core';
import { ChatService } from '../../../api-services/AIChatBoat/chat.service';

@Component({
  standalone: false,
  selector: 'app-chat-widget',
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.css']
})
export class ChatWidgetComponent implements OnInit, AfterViewChecked {
  @ViewChild('messagesEnd') messagesEnd!: ElementRef;

  inputText = '';
  shouldScroll = false;

  constructor(
    public chat: ChatService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void { }

  ngAfterViewChecked(): void {
    if (this.shouldScroll) {
      this.messagesEnd?.nativeElement
        .scrollIntoView({ behavior: 'smooth' });
      this.shouldScroll = false;
    }
  }

  async send(): Promise<void> {
    const text = this.inputText.trim();
    if (!text || this.chat.isModelStreaming()) return;
    this.inputText = '';
    this.shouldScroll = true;
    await this.chat.sendModelMessage(text);
    this.cdr.detectChanges();
  }

  async sendSuggestion(text: string): Promise<void> {
    this.shouldScroll = true;
    await this.chat.sendModelMessage(text);
    this.cdr.detectChanges();
  }

  onKeyDown(e: KeyboardEvent): void {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.send();
    }
  }

  autoGrow(el: HTMLTextAreaElement): void {
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 120) + 'px';
  }

  getBotLabel(bot: string): string {
    const labels: Record<string, string> = {
      'sysadmin-bot':   '🖥 IT & Assets',
      'hr-bot':         '👤 HR',
      'invoice-bot':    '🧾 Invoice',
      'po-bot':         '📦 Purchase Order',
      'timesheet-bot':  '⏱ Timesheet',
      'sow-bot':        '📋 Projects',
      'vendor-bot':     '🤝 Vendor',
      'jobportal-bot':  '💼 Jobs',
      'chatbot-master': '🤖 Assistant',
    };
    return labels[bot] ?? '🤖 AI';
  }

  trackById(index: number, msg: any): any {
    return msg.id ?? index;
  }
}